module.exports = __webpack_public_path__ + "static/media/ic-cheers-w.823bd376.svg";